import { Table } from "antd";
import TeamStandingsColumns from "./TeamStandingsColumns";
import styles from "./styles";

const rowkey = function (record) {
  return record.team_id;
};

const TeamStandingsTable = ({ title, standings }) => {
  return (
    <div>
      {/* <div style={styles.titleContainer}>
        <span style={styles.title}>{title}</span>
      </div> */}

      <Table
        dataSource={standings}
        columns={TeamStandingsColumns}
        size="small"
        pagination={false}
        rowKey={rowkey}
      />
    </div>
  );
};

export default TeamStandingsTable;
